import {Context} from '@nuxt/types';

export default function({route, redirect, store, $config}: Context) {
	const lineOfBusiness = process.env.LINE_OF_BUSINESS || '';
	const enabledSections = lineOfBusiness
		.split(',')
		.map(section => section.trim())
		.filter(Boolean);
	
	const allowedSections = new Set(enabledSections);
	const firstSection = enabledSections[0];
	const defaultDash = `/${firstSection}/${firstSection}_dash`;

	const [, section] = route.path.split('/');
	if (!section) {
		return;
	}

	if ((section === 'motor' || section === 'home') && !allowedSections.has(section)) {
		store.commit('SET_DOMAIN', firstSection);
		return redirect(defaultDash);
	}

	const enabledPages = $config.enabledPages || {};
	const enabledPagesBySection = $config.enabledPagesBySection || {};
	const excludedFromFlags = ['motor_dash', 'home_dash', 'login'];
	const pageName = route.path.split('/').pop();
	const sectionPageConfig = enabledPagesBySection[section] || {};
	const isPageDisabled = pageName && !excludedFromFlags.includes(pageName)
		? (enabledPages[pageName] === false || sectionPageConfig[pageName] === false)
		: false;
	if (isPageDisabled) {
		store.commit('SET_DOMAIN', section);
		return redirect(`/${section}/${section}_dash`);
	}
}
